import {
    ROOT,
    GET_CHAIN_ROOM_CATEGORY_LIST,
    CREATE_CHAIN_ROOM_CATEGORY,
    UPDATE_CHAIN_ROOM_CATEGORY,
    GET_CHAIN_ROOM_CATEGORY_DETAIL,
    CHAIN_ROOM_CATEGORY_CHANGE_STATUS,
    DELETE_CHAIN_ROOM_CATEGORY
} from "@/_helpers/constant.js";
import { requestOptions, handleResponse } from "@/_helpers";

//#region list of rooms
function getRoomCategoryList(data) {
    return fetch(ROOT + GET_CHAIN_ROOM_CATEGORY_LIST, requestOptions.post(data))
        .then(handleResponse)
        .then(data => {
            return data;
        });
}
function getDetail(id) {
    return fetch(ROOT + GET_CHAIN_ROOM_CATEGORY_DETAIL + `/${id}`, requestOptions.get())
        .then(handleResponse)
        .then(data => {
            return data;
        });
}
function remove(id) {
    return fetch(ROOT + DELETE_CHAIN_ROOM_CATEGORY + `/${id}`, requestOptions.get())
        .then(handleResponse)
        .then(data => {
            return data;
        });
}
function createRoomCategory(data) {
    return fetch(ROOT + CREATE_CHAIN_ROOM_CATEGORY, requestOptions.post(data))
        .then(handleResponse)
        .then(data => {
            return data;
        });
}
function updateRoomCategory(data) {
    return fetch(ROOT + UPDATE_CHAIN_ROOM_CATEGORY, requestOptions.post(data))
        .then(handleResponse)
        .then(data => {
            return data;
        });
}

function updateStatus(id) {
    return fetch(ROOT + CHAIN_ROOM_CATEGORY_CHANGE_STATUS + `/${id}`, requestOptions.get())
        .then(handleResponse)
        .then(data => {
            return data;
        });
}
//#endregion
export const ChainCategoryService = {
    getRoomCategoryList,
    remove,
    createRoomCategory,
    updateRoomCategory,
    getDetail,
    updateStatus
};
